import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { FacetedSearchRefinementList } from './filters/FacetedSearchRefinementList';
import { htmlToText } from '../../utils/dom';
import { useDispatch } from "react-redux";
import { setVisibleTables } from "../../grouped-table/store";

export function useClickOutside(ref, handler) {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler(event.target);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, handler]);
}

export const DropdownFilter = (props) => {
  const {label, filter} = props;

  const ref = useRef(null);

  const handleClickOutside = (target) => {
    if (ref.current) {
      if (target.classList.contains('filters__reset')) {
        return;
      }

      const dropdown = ref.current.parentElement.querySelector('.filter__wrapper');
      dropdown.classList.add('d-none');
    }
  };

  useClickOutside(ref, handleClickOutside);
  const handleClick = (e) => {
    const dropdown = e.target.parentElement.querySelector('.filter__wrapper');
    dropdown.classList.toggle('d-none');
  }

  return (
    <div className='filter filter--dropdown'>
      <button className='p--medium filter__label' onClick={handleClick}>{htmlToText(label)}</button>
      <div className='filter__wrapper d-none' ref={ref}>
        <div className='filter__content'>
          {[filter].map((filter, key) => {
            const widgets = {
              [filter.widget]: FacetedSearchRefinementList,
            }
            const Widget = widgets[filter.widget] || <div></div>;

            return <Widget
              key={key}
              showAll={true}
              header={filter.label || filter.fieldName}
              attributeName={filter.fieldName}
              attribute={filter.fieldName}
            />;
          })}
        </div>
      </div>
    </div>
  );
};

export function StaticDropdownFilter(props) {
  const {
    label = '',
    options = [],
    filtersVisibilitySetter,
  } = props;
  const dispatch = useDispatch();

  const optionsMap = new Map();
  const labelsMap = new Map();
  const tablesMap = new Map();
  options.forEach(item => {
    const {id, label, value, tables} = item;
    optionsMap.set(id, value);
    labelsMap.set(id, label);
    tablesMap.set(id, tables);
  });

  const ref = useRef(null);
  const [selectedValue, setSelectedValue] = useState(null);

  const handleClickOutside = (target) => {
    if (ref.current && target) {
      if (target.classList.contains('filters__reset')) {
        return;
      }

      const dropdown = ref.current.parentElement.querySelector('.filter__wrapper');
      if (dropdown) {
        dropdown.classList.add('d-none');
      }
    }
  };

  useClickOutside(ref, handleClickOutside);

  const handleClick = (e) => {
    const dropdown = e.target.parentElement.querySelector('.filter__wrapper');
    dropdown.classList.toggle('d-none');
  }

  const handleFilterItemClick = (e) => {
    const value = e.target.closest('li.ais-RefinementList-item').dataset['value'];

    const ids = optionsMap.get(value) || [];
    filtersVisibilitySetter(ids);
    setSelectedValue(labelsMap.get(value) || null);
    dispatch(  setVisibleTables(tablesMap.get(value) || []));
    e.target.closest('.filter__wrapper').classList.toggle('d-none');
    try {
      document.querySelector('.faceted-search-clear-filters button').click()
    } catch (e) {
    }
  }

  useEffect(() => {
    const [key, value] = optionsMap.entries().next().value;
    setSelectedValue(labelsMap.get(key) || null);
    filtersVisibilitySetter(value);
    dispatch(  setVisibleTables(tablesMap.get(key) || []));
  }, []);

  return (
    <div className='filter filter--dropdown filter--static'>
      <button className='p--medium filter__label' onClick={handleClick}>
        {selectedValue ? selectedValue : htmlToText(label)}
      </button>
      <div className='filter__wrapper d-none' ref={ref}>
        <div className="filter__content">
          <div className="fs-widget fs-widget--checkboxes">
            <div className="fs-widget__panel">
              <div className="ais-Panel">
                <div className="ais-Panel-body">
                  <div className="ais-RefinementList">
                    <ul className="ais-RefinementList-list">
                      {options.length > 0 && options.map(item => {
                        const {id, label} = item;

                        return (
                          <li key={id} className="ais-RefinementList-item" data-value={id}
                              onClick={handleFilterItemClick}>
                            <label className="ais-RefinementList-label">
                              <span className="ais-RefinementList-labelText">{label}</span>
                            </label>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
